import ProxyBase from '../../../../core/proxies/ProxyBase'

class ScoreCompanyProxy extends ProxyBase {
  getHightLight(params) {
    return this.get('Score/RiskScoreHighlight', params)
  }
}

export default new ScoreCompanyProxy()
